import QUERY from '@/api_app/AddressBook'
import { Toast } from 'vant';

const getDefaultState = () => {
  return {
    AddressOffset: 0,
    GetSetData: { list: [] },
    SearchData: [],
    getTableData: [],
    twoTitle: {},
    adressListLength: 0,
    scrollTopValue: 0,
    GetSetLabelList: [],
    starMarkList: [],
    noStarMarkList: []
  }
}

const state = getDefaultState()

const mutations = {
  SET_DATA: (state, { key, data }) => {
    state[key] = data;
  },
  offset_set: (state, data) => {
    state['AddressOffset'] = data
  },
  clear_SearchData: (state,data)=>{
    state['SearchData'] = {}
  },
  adressListLength: (state,data)=>{
    state['adressListLength'] = data.data
  }
}

const actions = {
  // 获取通讯录的标签
  GetAddressBook({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'GetAddressBook', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'GetAddressBook', data: data.data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取用户信息设置的标签
  GetSetLabel({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'GetSetLabel', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'GetSetLabelList', data: data.data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  // 删除自定义标签
  delCustomLabel({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'delCustomLabel', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'delCustomLabel', data: data.data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  // 保存自定义客户标签
  customerMarking({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'customerMarking', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'customerMarking', data: data.data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 保存自定义标签
  addCustomLabel({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'addCustomLabel', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'addCustomLabel', data: data.data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取通讯录的列表数据
  getTableData({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'getTableData', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('adressListLength', { key: 'adressListLength', data: state.adressListLength+=1 })
          let getTableData = state.getTableData || []
          if (state.AddressOffset == 0) {
            getTableData = data.data
          } else {
            for (let i in data.data) {
              getTableData.push(data.data[i])
            }
          }
          commit('SET_DATA', { key: 'getTableData', data: getTableData })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 搜索
  SearchData({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'getTableData', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          let SearchData = data.data
          commit('SET_DATA', { key: 'SearchData', data: SearchData })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

